import { ButtonLink } from '@vfde-brix/ws10/button-link';
import { startAppListening } from '../../../app/listener';
import { mountButtonLink } from '../../../components/ButtonLink';
import { selectCustomerConfig } from '../../app/slice';
import { selectSelectedTradeInDevice } from '../selectors';
import { selectIsTradeInSelected } from '../slice';

/**
 * Mount ButtonLink for Tauschbonus
 */
export const mountButtonLinkForTauschbonus = (containerId: string): ButtonLink | null => {
    const buttonLink = mountButtonLink(containerId);

    /* istanbul ignore if */
    if (!buttonLink) {
        return null;
    }

    listenForUpdates(buttonLink);

    return buttonLink;
};

const listenForUpdates = (buttonLink: ButtonLink) => {
    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectCustomerConfig(currentState).isHardwareOnly !== selectCustomerConfig(previousState).isHardwareOnly
            || selectIsTradeInSelected(currentState) !== selectIsTradeInSelected(previousState)
            || selectSelectedTradeInDevice(currentState) !== selectSelectedTradeInDevice(previousState)
        ,
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState();
            const customerConfig = selectCustomerConfig(state);
            const { isHardwareOnly, isTradeIn, isTauschbonus } = customerConfig;
            const isTradeInSelected = selectIsTradeInSelected(state);
            const selectedTradeInDevice = selectSelectedTradeInDevice(state);
            const shouldShowButtonLink = !isHardwareOnly && isTradeIn && isTauschbonus && isTradeInSelected && selectedTradeInDevice;

            buttonLink.toggleContainer(!shouldShowButtonLink);
        },
    });
};
